/* eslint-disable global-require */
import config from "../config";

/** */
class LangUtils {
    #lang;
    #supported = ["fa", "en"];
    #data = {};

    /**
     * @param {string} language [fa, en]
     */
    constructor(language = null) {
        this.#lang = language ?? config.lang;
        this.#data = require(`../lang/${this.#lang}`).lang;
    }

    /**
     *
     */
    get lang() {
        return this.#lang;
    }

    set lang(lang) {
        if (this.#supported.includes(lang)) {
            this.#lang = lang;
        }
    }

    /**
     * get translated key based on selected language
     * @param {string} key
     * @return {string|undefined}
     */
    get(key) {
        const data = this.#data;
        if (key in data) {
            return this.#data[key];
        }
        return key;
    }
}

const lang = new LangUtils();

/**
 *
 * @param {string} key
 * @return {string}
 * @private
 */
const _l = (key) => lang.get(key);

export default _l;
export { LangUtils, _l };
